import ballIcon from "../assets/messages/ball.png";
import { resolveBackendAssetUrl } from "./imageUtils";

export const LEAGUE_AVATAR_FALLBACK = ballIcon;
export const LEAGUE_AVATAR_ACCEPT = "image/jpeg,image/png";
export const MAX_LEAGUE_AVATAR_SIZE_BYTES = 5 * 1024 * 1024;
export const ALLOWED_LEAGUE_AVATAR_TYPES = new Set(["image/jpeg", "image/png"]);

const DEFAULT_LEAGUE_IMAGE_PATHS = new Set([
  "/uploads/leagues/default-league-image.png",
  "/uploads/leagues/default-league-image.svg",
]);

const normalizeLeagueImageUrl = (imageUrl) => {
  if (typeof imageUrl !== "string") return "";

  const trimmedUrl = imageUrl.trim();
  if (!trimmedUrl) return "";

  const lowerUrl = trimmedUrl.toLowerCase();
  if (lowerUrl.startsWith("/http://") || lowerUrl.startsWith("/https://")) {
    return trimmedUrl.slice(1);
  }

  return trimmedUrl;
};

const getPathname = (imageUrl) => {
  const normalizedUrl = normalizeLeagueImageUrl(imageUrl);
  if (!normalizedUrl) return "";

  try {
    return new URL(normalizedUrl, "https://nova.local").pathname;
  } catch (_) {
    return normalizedUrl;
  }
};

export const isDefaultLeagueImage = (imageUrl) => (
  DEFAULT_LEAGUE_IMAGE_PATHS.has(getPathname(imageUrl))
);

export const hasCustomLeagueImage = (imageUrl) => {
  const normalizedUrl = normalizeLeagueImageUrl(imageUrl);
  return Boolean(normalizedUrl) && !isDefaultLeagueImage(normalizedUrl);
};

export const getLeagueAvatarSrc = (imageUrl) => {
  const normalizedUrl = normalizeLeagueImageUrl(imageUrl);

  if (!normalizedUrl || isDefaultLeagueImage(normalizedUrl)) {
    return LEAGUE_AVATAR_FALLBACK;
  }

  return resolveBackendAssetUrl(normalizedUrl);
};
